import { render, staticRenderFns } from "./FormAddArea.vue?vue&type=template&id=7aca9568&"
import script from "./FormAddArea.vue?vue&type=script&lang=ts&"
export * from "./FormAddArea.vue?vue&type=script&lang=ts&"
import style0 from "./FormAddArea.vue?vue&type=style&index=0&id=7aca9568&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports